import {
  Box, Button, TextField, Typography,
} from '@mui/material';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { checkRut, prettifyRut } from 'react-rut-formatter';
import useStyles, { styles } from './styles';
import analytics from '../../utils/analytics';
import BancameBackdrop from '../BancameBackdrop';
import BancameAlert from '../Alert';

interface PaymentLoginProps {
  handlePaymentLogin: (rut: string, recaptchaValue: string | undefined) => Promise<null>;
  errorEndpoint: number | boolean;
}

export default function PaymentLogin(props: PaymentLoginProps) {
  const { handlePaymentLogin, errorEndpoint } = props;
  const classes = useStyles();

  const recaptchaRef = React.useRef<ReCAPTCHA>(null);
  const [recaptchaCheckError, setRecaptchaCheckError] = React.useState(false);
  const [rut, setRut] = React.useState('');
  const [touched, setTouched] = React.useState(false);
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');

  const handleRutChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const formattedRut = prettifyRut(e.target.value);
    setRut(formattedRut);
  };

  const handleRutBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const formattedRut = prettifyRut(e.target.value);
    if (!checkRut(formattedRut)) {
      setError('Por favor ingrese un RUT válido');
    } else {
      setError('');
    }
  };

  const recaptchaOnChange = () => {
    analytics.track('Click Checkbox', {
      texto: 'No soy un robot',
      initiator: 'usuario',
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    setRecaptchaCheckError(false);
    let recaptchaValue;
    if (recaptchaRef.current) {
      recaptchaValue = recaptchaRef.current.getValue();
      if (!recaptchaValue) {
        setRecaptchaCheckError(true);
        return setLoading(false);
      }
    }
    try {
      analytics.track('Click Boton', {
        text: 'Continuar',
        initiator: 'usuario',
      });
      return await handlePaymentLogin(rut, recaptchaValue);
    } catch (e) {
      setError('Ha ocurrido un error, por favor contáctanos si esto persiste.');
    } finally {
      setLoading(false);
    }
    return undefined;
  };

  React.useEffect(() => {
    if (errorEndpoint) {
      if (errorEndpoint === 404) {
        setErrorMessage('El RUT ingresado no se encuentra registrado.');
      } else {
        setErrorMessage('Ha ocurrido un error, por favor contáctanos.');
      }
    }
  }, [errorEndpoint]);

  return (
    <Box sx={styles.boxContainer}>
      <Typography variant="h6" align="center" gutterBottom>
        Por favor ingresa tu RUT
      </Typography>
      <br />
      <TextField
        onClick={() => setTouched(true)}
        onBlur={(e) => handleRutBlur(e)}
        className={classes.textInput}
        size="small"
        variant="outlined"
        autoComplete="off"
        placeholder="RUT"
        inputProps={{ style: { textAlign: 'center' } }}
        id="rut"
        name="rut"
        data-pw="payment-login-rut-input"
        autoFocus
        error={touched && Boolean(error)}
        helperText={touched ? error : ''}
        FormHelperTextProps={{ style: { textAlign: 'center' } }}
        value={rut}
        onChange={(e) => handleRutChange(e)}
      />
      <br />
      <ReCAPTCHA
        onChange={recaptchaOnChange}
        className={classes.recaptchaContainer}
        ref={recaptchaRef}
        sitekey={process.env.REACT_APP_CAPTCHA_PLRV2 as string}
      />
      {recaptchaCheckError && <Typography color="error" variant="caption">Queremos saber si no eres un robot </Typography>}
      <br />
      <br />
      <Button
        onClick={handleSubmit}
        disabled={loading}
        variant="contained"
        color="primary"
        sx={{ minWidth: '60%' }}
      >
        Continuar
      </Button>
      <BancameBackdrop openBackdrop={loading} loadingText="Cargando..." type="loading" />
      <BancameAlert
        openAlert={!!errorEndpoint}
        successMessage=""
        errorMessage={errorMessage}
        error
      />
    </Box>

  );
}
